/* eslint no-console:0 */
import MicroModal from 'micromodal';
import '../shared/application'
import '../front_office/stylesheets/application'
const images = require.context('../images', true);

window.MicroModal = MicroModal;